import { SET_LOADING, LoaderActionTypes} from './types';

export function setLoading(status: boolean): LoaderActionTypes {
    return {
      type: SET_LOADING,
      payload: status
    }
  }